/* global STUDIO_5_URL */

import { connect } from 'react-redux';
import { AccountMenu } from '@studio/navigation';

import { Link } from 'react-router-dom';
import { selectAccount } from 'next/entities/account';
import { selectAccounts } from 'next/entities/accounts';
import { logout, selectUser } from 'next/entities/user';
import { S5_ACCOUNT_SETTINGS, selectFeature } from 'next/entities/features';

const mapStateToProps = state => ({
  account: selectAccount(state),
  accounts: selectAccounts(state),
  user: selectUser(state),
  Link,
  hasS5AccountSettings: selectFeature(state, S5_ACCOUNT_SETTINGS),
  studio5Url: STUDIO_5_URL,
});

const mapDispatchToProps = {
  onLogout: logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
